export default __webpack_public_path__ + "static/media/lab-list-icon.ea5cf21c.svg";